import { getTheme, mergeStyleSets } from '@fluentui/react';
import { AccessibilityContrast, IPubcenterSpacing } from '../../../../../../theme';
import { ICommonStyleProps } from '../../../../../types';

type StyleProperties = 'container' | 'headerSection';
type SetupCardStyles = Record<StyleProperties, string>;

export const getStyles = (props: ICommonStyleProps): SetupCardStyles => {
  const { theme } = props;
  const spacing = theme.spacing as IPubcenterSpacing;
  const { Activated } = AccessibilityContrast;

  return mergeStyleSets({
    container: {
      display: 'grid',
      gridTemplateColumns: `repeat(auto-fit, minmax(${spacing.size320}, 1fr))`,
      gap: spacing.size14,
      justifyContent: 'space-between',
      cursor: 'pointer',
      [Activated]: {
        color: 'windowtext',
        borderColor: 'window',
        forcedColorAdjust: 'none',
      },
    },
    headerSection: {
      margin: `${spacing.size15} 0`,
      fontSize: spacing.size20,
      fontWeight: '600',
    },
  });
};

export function getClassNames<PropType>(props?: PropType) {
  return getStyles({ theme: getTheme(), ...props });
}
